var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContinue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2717 11.1441L12.9341 2.75413C12.4628 2.28183 11.6967 2.28183 11.2255 2.75413C10.753 3.22644 10.753 3.99359 11.2255 4.4659L18.7124 11.9999L11.2255 19.5339C10.753 20.0062 10.753 20.7734 11.2255 21.2457C11.6979 21.718 12.4628 21.718 12.9341 21.2457L21.2705 12.8557C21.726 12.4016 21.7272 11.5996 21.2717 11.1441Z",
    fill: "#7B5DF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.801 11.1441L4.46458 2.75413C3.9921 2.28183 3.22723 2.28183 2.75596 2.75413C2.28348 3.22644 2.28348 3.99359 2.75596 4.4659L10.2417 11.9999L2.75475 19.5339C2.28227 20.0062 2.28227 20.7734 2.75475 21.2457C3.22723 21.718 3.9921 21.718 4.46338 21.2457L12.7998 12.8557C13.2553 12.4016 13.2565 11.5996 12.801 11.1441Z",
    fill: "#7B5DF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinue);
export default __webpack_public_path__ + "static/media/continue.18f8eb53367bca15ab1be356eb654355.svg";
export { ForwardRef as ReactComponent };